import { featureItems } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="w-full max-w-[1280px] mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">特色优势</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">为什么超过百万用户选择桃子视频</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {featureItems.map((item) => (
            <div key={item.id} className="group bg-background-50 rounded-xl p-6 border border-background-200/70 hover:border-primary-300 transition-all duration-300 cursor-pointer text-center">
              <div className="w-14 h-14 md:w-16 md:h-16 mx-auto mb-4 rounded-2xl bg-primary-50 flex items-center justify-center group-hover:bg-primary-100 transition-colors duration-200">
                <i className={`${item.icon} text-2xl text-primary-500`}></i>
              </div>
              <h3 className="text-base font-heading text-foreground-900 mb-2">{item.title}</h3>
              <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}